type WindowWithWebView = Window &
  typeof globalThis & {
    ReactNativeWebView?: { postMessage: (message: string) => void }
  }

export function serializeHostPayload(payload: Record<string, unknown>): string {
  return JSON.stringify(payload)
}

export function postWebViewHostPayload(
  payload: Record<string, unknown>,
): boolean {
  const w = window as WindowWithWebView
  if (
    w.ReactNativeWebView &&
    typeof w.ReactNativeWebView.postMessage === 'function'
  ) {
    w.ReactNativeWebView.postMessage(serializeHostPayload(payload))
    return true
  }
  return false
}

export function postIframeHostPayload(
  payload: Record<string, unknown>,
): boolean {
  const w = window as WindowWithWebView
  const message = serializeHostPayload(payload)
  const target =
    w.parent && w.parent !== w
      ? w.parent
      : w.top && w.top !== w
      ? w.top
      : null

  if (target && typeof target.postMessage === 'function') {
    target.postMessage(message, '*')
    return true
  }

  return false
}

export function postHostPayload(payload: Record<string, unknown>): boolean {
  const sentToWebView = postWebViewHostPayload(payload)
  const sentToIframe = postIframeHostPayload(payload)
  return sentToWebView || sentToIframe
}

/** Fallback when the host does not take over: in-app router push, otherwise a full load. */
export function pushRoute(url: string): void {
  if ((window as any).routerHistory) {
    ;(window as any).routerHistory.push(url)
  } else {
    window.location.href = url
  }
}

export function pdfDataUrlToBase64(dataUrl: string): string | null {
  const match = /^data:application\/pdf;base64,(.+)$/i.exec(dataUrl)
  return match ? match[1] : null
}
